import { AppsRoutes, useAppsNavigate } from '@wellesley/router'
import { useSelector } from 'react-redux'
import { useCallback, useEffect, useRef } from 'react'
import { appsListSlice } from '../appsListSlice'
import { useGetAppLink } from './useGetAppLink'

type LastAppProps = {
  username?: string
  groupname?: string
  link: string
  isActive: boolean
}

const storePrefix = 'lastAppFor'

const getKey = (id: string = 'global') => `${storePrefix}:${id}`

export const useSetLastApp = ({
  link,
  username,
  groupname,
  isActive,
}: LastAppProps) => {
  const key = getKey(groupname || username || 'global')

  useEffect(() => {
    if (isActive) {
      localStorage.setItem(key, link)
    }
  }, [isActive, link])
}

export const useOpenLastApp = () => {
  const navigate = useAppsNavigate()
  const getLink = useGetAppLink()
  const list = useSelector(appsListSlice.selectors.selectList)

  const defaultLinkRef = useRef<AppsRoutes | null>(null)
  defaultLinkRef.current = list && getLink(list[0])

  const openLastApp = useCallback(
    (id: string) => {
      const key = getKey(id)
      const lastLink =
        (localStorage.getItem(key) as AppsRoutes) || defaultLinkRef.current

      if (lastLink) {
        navigate(lastLink)
      }
    },
    [navigate, defaultLinkRef.current],
  )

  return { openLastApp }
}
